import { BaseModel } from 'core/base.model';

import {
  TransactionStatusType,
  TransactionStatusTypeValidator,
  TTransactionStatusType,
} from '../../types/transaction-status.type';
import {
  TransactionType,
  TransactionTypeValidator,
  TTransactionType,
} from '../../types/transaction.type';
import dateHelper from '../../../../core/helpers/dateHelper';

export class CashBook extends BaseModel {
  transactionCode: number = 0;
  transactionType: TTransactionType = TransactionType.withdrawal;
  status: TTransactionStatusType = TransactionStatusType.reconciled;
  date: string = dateHelper.format(new Date(), 'yyyy-MM-dd');
  amount: number = 0;
  notes: string = '';

  static build(dto: CashBook) {
    const entity = new CashBook(dto.id, dto.createdAt, dto.updatedAt);
    entity.transactionCode = dto.transactionCode * 1.0;
    entity.transactionType = dto.transactionType;
    entity.status = dto.status;
    entity.date = dto.date;
    entity.amount = dto.amount * 1.0;
    entity.notes = dto.notes;
    if (!TransactionTypeValidator(entity.transactionType))
      throw new Error('Informe o tipo de transação.');
    if (!TransactionStatusTypeValidator(entity.status))
      throw new Error('Informe o status da transação.');
    // deve ser maior que 2025-01-01
    if (+dateHelper.toDate(entity.date) < 1735700400000)
      throw new Error('Informe uma data válida.');
    if (entity.amount <= 0) throw new Error('Valor da transação deve ser maior que zero.');
    if (!entity.notes) throw new Error('Informe a descrição da transação.');
    return entity;
  }
}
